/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import style from './addItem.module.scss';
import AddImage from 'icons/addImage';
import cx from 'classnames';
import ReactDOM from 'react-dom';
import DropCircle from 'components/dropCircle/dropCircle';
import { CategoryId } from 'store/types';
import { getAccept } from 'utils/utils';

export default function ListItemAdd({
  onChange,
  onFileDrop,
  currentCategory,
}: {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFileDrop: (e: React.DragEvent<Element>) => void;
  currentCategory: CategoryId;
}) {
  const inputFileRef = useRef<HTMLInputElement>(null);
  // TODO: в хук
  const [isHover, setIsHover] = useState(false);
  const [mouseCoordinates, setMouseCoordinates] = useState({
    x: 0,
    y: 0,
  });

  return (
    <div
      className={cx(style.container, style.add)}
      onClick={() => inputFileRef?.current?.click()}
      onDrop={(e) => {
        onFileDrop(e);
        setIsHover(false);
      }}
      onDragEnter={(e) => {
        e.stopPropagation();
        e.preventDefault();

        setIsHover(true);
      }}
      onDragOver={(e) => {
        e.stopPropagation();
        e.preventDefault();

        setMouseCoordinates({
          x: e.pageX,
          y: e.pageY,
        });
      }}
      onDragLeave={(e) => {
        e.stopPropagation();
        e.preventDefault();

        setIsHover(false);
      }}
    >
      {isHover ? '' : <AddImage className={style.icon}></AddImage>}
      <input
        className={'hidden'}
        type="file"
        accept={getAccept(currentCategory)}
        ref={inputFileRef}
        multiple={true}
        onChange={(e) => {
          onChange(e);
          if (inputFileRef.current) {
            inputFileRef.current.value = '';
          }
        }}
      />
      {ReactDOM.createPortal(
        <DropCircle isVisible={isHover} {...mouseCoordinates}></DropCircle>,
        document.body
      )}
    </div>
  );
}
